<template>
    <el-dialog
            title="选择导入文件"
            :visible="true"
            width="30%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px"  class="mt20">
            <el-form-item label="类型:">
                <el-radio v-model="form.to_type" :label="2">经销商</el-radio>
                <el-radio v-model="form.to_type" :label="3">门店</el-radio>
            </el-form-item>
            <el-form-item label="选择导入文件:">
                <el-upload
                        ref="upload"
                        class="upload-demo"
                        :action="url"
                        :before-upload="beforeUpLoad"
                        :on-success="successUpload"
                        accept=".xlsx"
                        name="outwarehouse_file"
                        :file-list="fileArray"
                        :data="form"
                        :auto-upload="false"
                >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传.xlsx文件</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="模板下载:">
                <a style="cursor: pointer;color:red" @click="downloadTem()">下载模板</a>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="submit()">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "importData",
        data(){
            return {
                form: {
                    to_type:2
                },
                fileArray: [],
                url:'http://logistics.c.'+process.env.VUE_APP_URL + '/outwarehouses.import',
                headers: {
                    'Content-Type': 'multipart/form-data'  //之前说的以表单传数据的格式来传递fromdata
                },

            }
        },
        methods:{
            beforeUpLoad(file){
            },
            successUpload(response, file, fileList){
                this.$message({
                    message: message,
                    type: 'success'
                });

            },
            //模板下载
            downloadTem(){
                let url = '',access_tokens = localStorage.getItem('access_token');
           

                window.open(process.env.VUE_APP_URL
                    + '/outwarehouses.template?signature=' + this.$md5(access_tokens)
                )
            },
            submit(){
                this.$refs.upload.submit();
                this.$emit('handleClose');
                this.$emit('refresh');
            },
        handleClose(){
            this.$emit('handleClose');
        }
    }
    }
</script>

<style scoped>

</style>